/* unplugin-vue-components disabled */import script from "./RoleDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleDetails.vue?vue&type=script&setup=true&lang=js"

import "./RoleDetails.vue?vue&type=style&index=0&id=3b2b1ac2&lang=scss"

const __exports__ = script;

export default __exports__